import axios from "axios";
import { useState } from "react";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { downloadTableColumn, selectOptionsKeyName, statusOptions } from "data/globalData";
import { GlobalState } from "context/GlobalContext";
import { deleteColumn, getColDefaultValue, isColumnDefault } from "components/PimDashboard/data";
import RenderInputField from "../RenderInputField/RenderInputField";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { arrType, converAttrToDatagridCol, datatypes, inputTypes } from "data/globalData";
import { Box, Button, CircularProgress, InputLabel, Stack, TextField, Typography } from "@mui/material";
import moment from "moment";
import { CustomDatagridPagination, getDefaultFooterStyles } from "../CustomDatagridPagination/CustomDatagridPagination";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";

export const defFilesColumns = [
	{
		name: "Effective Date",
		key: "effective_date",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: "false", UNIQUE: false },
		data: {},
		data_type: datatypes.DATE.key,
		sort_no: 1,
		group: "",
		default_value: moment().format("YYYY-MM-DD"),
	},
	{
		name: "File Name",
		key: "file_name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: false, DISPLAY: "false", UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
	{
		name: "File Type",
		key: "file_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: "false", UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
	// {
	// 	name: "Upload File",
	// 	key: "file",
	// 	input_type: inputTypes.ENTER.key,
	// 	constraints: { NOTNULL: true, DISPLAY: "false", UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.FILE.key,
	// 	sort_no: 1,
	// 	group: "",
	// },
	{
		name: "URL",
		key: "url",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
	},
];
export const fileColumn = {
	name: "File",
	key: "raw_file",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: false, DISPLAY: false, UNIQUE: false },
	data: {},
	data_type: datatypes.FILE.key,
	sort_no: 1,
	group: "",
};

const defFileRenderCell = ({ row, field }) =>
	row?.[fileColumn.key] ? "To be uploaded" : <Button startIcon={<DownloadRoundedIcon />} />;

const AddFiles = ({ columns = defFilesColumns, handleAddFile, handleDownload, handleDelete, files = [], setFiles, addNewDefault }) => {
	const { setSnackBar, snackBar, setSnackBarOpen } = GlobalState();

	const getDef = () => {
		let obj = { id: new Date().valueOf() };
		columns?.forEach((attr) => {
			obj[attr.key] = getColDefaultValue(attr);
		});
		if (addNewDefault) return { ...obj, ...addNewDefault };
		return obj;
	};
	const defFields = getDef();
	console.log(defFields, "sdhmbgaks");
	const [newFileDetails, setNewFileDetails] = useState(defFields);
	const [file, setFile] = useState();
	const [loading, setLoading] = useState(false);
	const [dgColumns, setDgColumns] = useState((prev) => {
		let arr = columns.map((row) => converAttrToDatagridCol(row));
		if (typeof handleDownload === "function") arr = [...arr, downloadTableColumn(handleDownload)];
		if (typeof handleDelete === "function") arr = [...arr, deleteColumn(handleDelete, false)];
		return arr;
	});

	const handleFileChange = (e) => {
		const newFile = e.target.files[0];
		const newFileName = `${newFile.name}_${new Date().valueOf()}`;
		const modifiedFile = new File([newFile], newFileName, { type: newFile.type });
		setFile(modifiedFile);
	};

	// console.log("FILES", files);

	const handleSubmit = async () => {
		setLoading(true);
		let pendingFields = [];
		columns
			.filter((row) => row?.input_type !== inputTypes.AUTO_GENERATE.key && row?.constraints.NOTNULL === true)
			.forEach((attr) => {
				console.log(attr, "sadnbjaskd");
				if (isColumnDefault(attr, newFileDetails[attr.key])) pendingFields.push(attr);
			});
		console.log(columns, pendingFields, "sadnbjaskd");
		console.log(newFileDetails[fileColumn.key], "sadnbjaskd");

		if (!newFileDetails[fileColumn.key] || !file) pendingFields.push(fileColumn);
		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);

			return;
		}

		try {
			console.log(newFileDetails, "sdbksadnks");
			const res = await handleAddFile({ ...newFileDetails, [fileColumn.key]: file }, file);

			if (res) {
				setNewFileDetails(defFields);
				document.getElementById("upload_file").value = null;
				setLoading(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoading(false);
		}
	};

	// const handleCellClick = async (params) => {
	// 	console.log("params", params);
	// 	if (params.field === fileColumnKey && !params.row?.[fileColumn.key]) {
	// 		try {
	// 			const { data } = await axios.post("/api/ebo_store_v4/generate_signed_url", {
	// 				filePath: params.row[fileColumnKey], // assume this comes from your DB row
	// 			});
	// 			window.open(data.data, "_blank");
	// 		} catch (error) {
	// 			console.error("Failed to generate signed URL:", error);
	// 			alert("Error downloading file");
	// 		}
	// 	}
	// };

	// for datagrid footer
	const footerHeight = 40; // You can change this value
	const footerBackgroundColor = grey[200]; // You can change this value
	const dynamicFooterStyles = getDefaultFooterStyles(footerHeight, footerBackgroundColor);
	const customPaginationProps = {
		paginationHeight: footerHeight, // Ensure pagination component matches footer height
		paginationBgColor: footerBackgroundColor, // Ensure pagination component matches footer background
	};

	return (
		<Box display="flex" width="100%" alignItems="center" justifyContent="space-around">
			<Box width="65%" height={300}>
				<Typography variant="h6" width="100%">
					Files
				</Typography>

				<DataGrid
					rows={files || []}
					getRowId={(row) => row.id}
					columns={dgColumns}
					sx={{
						minHeight: 220,
						maxHeight: 275,
						width: "100%",
						border: "none",
						"& .MuiDataGrid-row": {
							// borderBottom: "1px solid lightgray",
							cursor: "pointer",
							border: "none",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[200],
						},
						...dynamicFooterStyles,
					}}
					columnHeaderHeight={35}
					rowHeight={40}
					disableAutosize
					disableRowSelectionOnClick
					// onCellClick={handleCellClick}
					slots={{
						// toolbar: GridToolbar,
						pagination: (props) => <CustomDatagridPagination {...props} {...customPaginationProps} />,
					}}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 5 },
						},
					}}
				/>
			</Box>
			<Stack
				width="30%"
				p={1}
				borderRadius={0}
				sx={{ background: grey[100], borderRadius: "2px" }}
				alignItems="center"
				spacing={1}
				height={300}>
				<Typography variant="h6" width="94%">
					Add File
				</Typography>
				{columns
					?.filter((row) => row?.input_type !== inputTypes.AUTO_GENERATE.key)
					.map((col) => {
						return (
							<RenderInputField
								column={{ ...col }}
								data={newFileDetails}
								setData={setNewFileDetails}
								width="94%"
								selectOptObjName={selectOptionsKeyName}
							/>
						);
					})}
				<RenderInputField
					column={fileColumn}
					data={newFileDetails}
					setData={setNewFileDetails}
					id="upload_file"
					width="94%"
					onChangeCallBack={(e, val) => handleFileChange(e)}
				/>
				<Box width="90%">
					<Button
						startIcon={loading && <CircularProgress color="inherit" size="20px" />}
						disabled={loading}
						variant="contained"
						sx={{ margin: "auto", width: "50%" }}
						onClick={handleSubmit}>
						{loading ? "Loading..." : "Add"}
					</Button>
				</Box>
			</Stack>
		</Box>
	);
};
export default AddFiles;
